<app-customer-selection-page [customers]="customers$ | async"
                             [customerSelected]="customerSelected$ | async"
                             [loading]="isLoading$ | async"
                             (onExpand)="expand()"
                             (onSelect)="select($event)"
                             (onSearch)="search($event)"
></app-customer-selection-page>
